import { h, Component } from 'preact';
import { joinClasses, debounce } from 'utils/utils';

import HTML from 'components/core/html/html';

import s from 'components/bolt/tooltip/tooltip.sss';

export default class Tooltip extends Component {
	constructor(props) {
		super(props);
		this.toggleTooltip = this.toggleTooltip.bind(this);
		this.debouncedHideTooltip = debounce(this.hideTooltip.bind(this), props.selfHideMilliseconds || 100);
		this.state = {
			displayTooltip: !!this.props.isOpen
		};
	}

	hideTooltip() {
		this.setState({ displayTooltip: false });
	}


	toggleTooltip () {
		let displayTooltip = !this.state.displayTooltip;

		if (this.props.showCondition !== undefined) {
			this.debouncedHideTooltip();
		}

		if (this.shouldHide || !this.props.showCondition) {
			displayTooltip = false;
		}

		this.setState({ displayTooltip });

		if (this.props.showCondition && !displayTooltip && !this.shouldHide && this.$bubble) {
			this.$bubble.style.display = 'block';
		}

		if (!displayTooltip) {
			this.props.onHide?.();
		} else {
			this.props.onShow?.();
		}
	}

	componentDidUpdate(prevProps) {
		const { stageIndex } = this.props;

		if (stageIndex && stageIndex !== prevProps.stageIndex) {
			this.shouldHide = true;
		}
	}

	componentWillUpdate(prevProps) {
		if (!this.$bubble) return;

		const { showCondition, stageIndex } = this.props;

		if ((stageIndex && stageIndex !== prevProps.stageIndex) || (showCondition && !prevProps.showCondition)) {
			this.$bubble.style.display = 'none';
		}
	}

	render() {
		const { data, position, class: extraClass, isMobile, id, icon } = this.props;
		const { title, content, buttonTooltip } = data;
		const displayTooltip = this.state.displayTooltip;

		return (
			<div>
				{(displayTooltip && isMobile) && <div class={s.overlay} />}
				<div id={id} class={joinClasses(s.tooltip, isMobile && s.mobileTooltip )}>
					{this.state.displayTooltip && (
						<div class={joinClasses(s.bubble, s[position])} ref={e => this.$bubble = e}>
							<div class={joinClasses(s.message, extraClass)}>
								{!!icon && <div class={s.icon}>{icon}</div>}
								{!!title && <HTML class={s.title} content={title} markdown />}
								{!!content && <HTML class={s.content} content={content} markdown />}
								{isMobile && !!buttonTooltip && <button class={s.close} onClick={this.toggleTooltip}>{buttonTooltip}</button>}
							</div>
						</div>
					)}
					<span class={s.trigger} onClick={this.toggleTooltip}>
						{this.props.children}
					</span>
				</div>
			</div>
		);
	}
}
